const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);

const normalizeHostname = (hostname) => (hostname || "").toLowerCase();

export const getRuntimeEnvironment = () => {
  if (typeof window === "undefined") {
    return {
      label: "Unknown",
      color: "default",
      description: "Runtime environment is unavailable on the server.",
      acronym: "UN",
    };
  }

  const hostname = normalizeHostname(window.location.hostname);
  const origin = window.location.origin;

  if (LOCAL_HOSTNAMES.has(hostname) || hostname.endsWith(".local")) {
    return {
      label: "Local",
      color: "default",
      description: origin,
      acronym: "LOC",
    };
  }

  if (hostname.includes("dev")) {
    return {
      label: "Dev",
      color: "processing",
      description: origin,
      acronym: "DEV",
    };
  }

  if (hostname.includes("test")) {
    return {
      label: "UAT",
      color: "gold",
      description: origin,
      acronym: "UAT",
    };
  }
  
  if (hostname.includes("uat")) {
    return {
      label: "UAT",
      color: "gold",
      description: origin,
      acronym: "UAT",
    };
  }

  if (hostname.includes("qa")) {
    return {
      label: "QA",
      color: "purple",
      description: origin,
      acronym: "QA",
    };
  }

  return {
    label: "Production",
    color: "green",
    description: origin,
    acronym: "PROD",
  };
};
